'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, MapPin, Gift, Ticket } from 'lucide-react';
const highlights = [{
  icon: Gift,
  label: 'Offers & freebies'
}, {
  icon: Ticket,
  label: 'Tastings & events'
}, {
  icon: MapPin,
  label: 'New Products'
}];
export function ConsumerFastTrack() {
  const $ = _c(8);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-primary-100/40 blur-3xl" />;
    t1 = <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-amber-100/50 blur-2xl" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="inline-flex items-center gap-2 text-primary-600 font-semibold text-2xl sm:text-3xl mb-4"><span>🫵🏻 Here to discover and experience new and fun things for yourself?</span></div>;
    t3 = <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 leading-tight mb-4">Find your next things to try</h2>;
    t4 = <p className="text-gray-600 text-base sm:text-lg mb-6 max-w-md mx-auto md:mx-0">Browse offers, tastings, events and new products from brands all over the country.</p>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-wrap justify-center md:justify-start gap-3 mb-8">{highlights.map(_temp)}</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex-1 text-center md:text-left">{t2}{t3}{t4}{t5}<Link href="/opportunities" className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-600 text-white font-bold rounded-full shadow-lg shadow-primary-200/50 hover:bg-primary-700 hover:shadow-xl transition-all cursor-pointer text-base group">Explore What's On<ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" /></Link></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section className="relative overflow-hidden bg-gradient-to-r from-orange-50 via-rose-50 to-amber-50">{t0}{t1}<div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-20"><div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16">{t6}<div className="hidden md:grid grid-cols-2 gap-4 w-72 lg:w-80 shrink-0">{[{
              src: "https://images.unsplash.com/photo-1742972459942-aed536c720cf?auto=format&fit=crop&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&q=80&w=600&h=600",
              alt: "Packaged chips and branded snack bags on a retail shelf"
            }, {
              src: "https://images.unsplash.com/photo-1755752919046-a6543db419cc?auto=format&fit=crop&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&q=80&w=600&h=600",
              alt: "Energy drink cans and bottled beverages lined up on shelves"
            }, {
              src: "https://images.unsplash.com/photo-1761059080249-3f0fe21958a5?auto=format&fit=crop&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&q=80&w=600&h=600",
              alt: "Packaged bottled drinks arranged in a convenience store fridge"
            }, {
              src: "https://images.unsplash.com/photo-1749648537909-67e35a37fbbb?auto=format&fit=crop&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&q=80&w=600&h=600",
              alt: "Convenience store shelf of packaged drinks with canned snacks in the foreground"
            }].map(_temp2)}</div></div></div></section>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}
function _temp2(img, i) {
  return <div key={i} className={`aspect-square rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 ${i === 1 ? "translate-y-3" : i === 2 ? "-translate-y-3" : ""}`}><img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="lazy" /></div>;
}
function _temp(t0) {
  const {
    icon: Icon,
    label
  } = t0;
  return <span key={label} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/80 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-gray-200/60"><Icon className="w-3.5 h-3.5 text-primary-500" />{label}</span>;
}